"use strict";
module.exports = validate20;
module.exports.default = validate20;
var schema22 = { "$schema": "http://json-schema.org/draft-07/schema#", "additionalProperties": false, "properties": { "filter": { "description": "Filter string", "type": "string" }, "numberOfSuggestions": { "description": "Number of suggestions to be returned", "type": "number" } }, "type": "object" };
function validate20(data, valCxt) {
    "use strict";
    ;
    if (valCxt) {
        var instancePath = valCxt.instancePath;
        var parentData = valCxt.parentData;
        var parentDataProperty = valCxt.parentDataProperty;
        var rootData = valCxt.rootData;
    }
    else {
        var instancePath = "";
        var parentData = undefined;
        var parentDataProperty = undefined;
        var rootData = data;
    }
    var vErrors = null;
    var errors = 0;
    if (data && typeof data == "object" && !Array.isArray(data)) {
        for (var key0 in data) {
            if (!((key0 === "filter") || (key0 === "numberOfSuggestions"))) {
                var err0 = { instancePath: instancePath, schemaPath: "#/additionalProperties", keyword: "additionalProperties", params: { additionalProperty: key0 }, message: "must NOT have additional properties", schema: false, parentSchema: schema22, data: data };
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
        if (data.filter !== undefined) {
            var data0 = data.filter;
            if (typeof data0 !== "string") {
                var err1 = { instancePath: instancePath + "/filter", schemaPath: "#/properties/filter/type", keyword: "type", params: { type: "string" }, message: "must be string", schema: schema22.properties.filter.type, parentSchema: schema22.properties.filter, data: data0 };
                if (vErrors === null) {
                    vErrors = [err1];
                }
                else {
                    vErrors.push(err1);
                }
                errors++;
            }
        }
        if (data.numberOfSuggestions !== undefined) {
            var data1 = data.numberOfSuggestions;
            if (!((typeof data1 == "number") && (isFinite(data1)))) {
                var err2 = { instancePath: instancePath + "/numberOfSuggestions", schemaPath: "#/properties/numberOfSuggestions/type", keyword: "type", params: { type: "number" }, message: "must be number", schema: schema22.properties.numberOfSuggestions.type, parentSchema: schema22.properties.numberOfSuggestions, data: data1 };
                if (vErrors === null) {
                    vErrors = [err2];
                }
                else {
                    vErrors.push(err2);
                }
                errors++;
            }
        }
    }
    else {
        var err3 = { instancePath: instancePath, schemaPath: "#/type", keyword: "type", params: { type: "object" }, message: "must be object", schema: schema22.type, parentSchema: schema22, data: data };
        if (vErrors === null) {
            vErrors = [err3];
        }
        else {
            vErrors.push(err3);
        }
        errors++;
    }
    validate20.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validateAutocompleteOptionsSchema.js.map